import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';
import { HomepageAdExtensionMap } from 'client/tracking/maps/common/homepage-ad-extension';
import { generateTrackingIds } from 'site-modules/shared/utils/make-model-zip';
import { getSearchByModuleTrackingMap } from 'client/tracking/maps/common/search-by-module';
import { CPO_CARS_PAGE_NAME } from 'site-modules/cpo/constants/cpo';

export const MMZ_CPO_TRACKING_IDS = generateTrackingIds(CPO_CARS_PAGE_NAME, 'mmz');

const map = {
  cpo_make_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.MAKE_SELECT),
  cpo_view_program: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_CPO_PROGRAM
  ),
  cpo_view_page: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_CPO_PROGRAM),
  cpo_view_article: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_ARTICLE),

  [MMZ_CPO_TRACKING_IDS.makeSelectTrackingId]: TrackingEvent.actionStart(
    TrackingConstant.ACTION_MMZ_SELECT,
    TrackingConstant.MAKE_SELECT
  ),

  [MMZ_CPO_TRACKING_IDS.modelSelectTrackingId]: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMZ_SELECT,
    TrackingConstant.MODEL_SELECT
  ),

  ...getSearchByModuleTrackingMap(MMZ_CPO_TRACKING_IDS),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
  ...HomepageAdExtensionMap,
};
